<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <day-panel></day-panel>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-sm-6" :class="'text-left'">
                <h5 class="card-category">Total Information For This Year</h5>
                <h2 class="card-title">Performance</h2>
              </div>
              <div class="col-sm-6">
                <div class="btn-group btn-group-toggle"
                     :class="'float-right'"
                     data-toggle="buttons">
                  <label v-for="(option, index) in bigLineChartCategories"
                         :key="option"
                         class="btn btn-sm btn-primary btn-simple"
                         :class="{active: bigLineChart.activeIndex === index}"
                         :id="index">
                    <input type="radio"
                           @click="initBigChart(index)"
                           name="options" autocomplete="off"
                           :checked="bigLineChart.activeIndex === index">
                    {{option}}
                  </label>
                </div>
              </div>
            </div>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        ref="bigChart"
                        chart-id="big-line-chart"
                        :chart-data="bigLineChart.chartData"
                        :gradient-colors="bigLineChart.gradientColors"
                        :gradient-stops="bigLineChart.gradientStops"
                        :extra-options="bigLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">Working Days For This Year</h5>
          </template>
          <div class="chart-area">
            <bar-chart style="height: 100%"
                       ref="blueChart"
                       chart-id="blue-bar-chart"
                       :chart-data="blueBarChart.chartData"
                       :gradient-stops="blueBarChart.gradientStops"
                       :extra-options="blueBarChart.extraOptions">
            </bar-chart>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';
  import * as chartConfigs from '@/components/Charts/config';
  import TaskList from './Dashboard/TaskList';
  import UserTable from './Dashboard/UserTable';
  import config from '@/config';
  import axios from "axios";
  import {setCookie, url} from "../plugins/axios";
  import NotificationTemplate from "./Notifications/NotificationTemplate";
  import DayPanel from "./Dashboard/DayPanel";

  export default {
    components: {
      DayPanel,
      LineChart,
      BarChart,
      TaskList,
      UserTable
    },
    data() {
      return {
        chartLabels:['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        chartData: {time: [], payroll: [], days: []},
        showBigChart: false,
        bigLineChart: {
          allData: [],
          activeIndex: 0,
          chartData: {
            datasets: [{
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: []
            }],
            labels: this.chartLabels,
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.4, 0],
          categories: [],

        },
        blueBarChart: {
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            responsive: true,
            tooltips: {
              backgroundColor: '#f5f5f5',
              titleFontColor: '#333',
              bodyFontColor: '#666',
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest"
            },
            scales: {
              yAxes: [{
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(29,140,248,0.0)',
                  zeroLineColor: "transparent",
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 30,
                  padding: 20,
                  fontColor: "#848588"
                }
              }],
              xAxes: [{
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(220,53,69,0.1)',
                  zeroLineColor: "transparent",
                },
                ticks: {
                  padding: 20,
                  fontColor: "#959595"
                }
              }]
            }
          },
          chartData: {
            labels: this.chartLabels,
            datasets: [{
              label: "Months",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            }]
          },
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.4, 0],
        },
      }
    },
    computed: {
      bigLineChartCategories() {
        return this.$t('dashboard.chartCategories');
      }
    },
    methods: {
      notifyVue(type,message) {

      },
      initBigChart(index) {
        let chartData = {
          datasets: [{
            fill: true,
            borderColor: config.colors.primary,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.primary,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: config.colors.primary,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.bigLineChart.allData[index]
          }],
          labels: this.chartLabels,
        };
        this.$refs.bigChart.updateGradients(chartData);
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      initBlueChart() {
        let chartData = {
          labels: this.chartLabels,
          datasets: [{
            label: "Months",
            fill: true,
            borderColor: config.colors.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: this.chartData.days,
          }]
        };
        this.$refs.blueChart.updateGradients(chartData);
        this.blueBarChart.chartData = chartData;
      },
      getDashInfo(){
        this.showBigChart = false;
        axios
          .get(url + 'dashboard/myself/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            for (let i = 0; i < 12; i++ ){
              this.chartData.time[i] = 0;
              this.chartData.payroll[i] = 0;
              this.chartData.days[i] = 0;
            }
            if (response.data.error === ''){
              if (response.data.result !== null){
                let temp = response.data.result;
                for(let key in temp) {
                    switch (key) {
                      case 'Jan':{
                        this.chartData.time[0] = temp[key].totalHours;
                        this.chartData.payroll[0] = temp[key].totalMoney;
                        this.chartData.days[0] = temp[key].totalDays;
                        break;
                      }
                      case 'Feb':{
                        this.chartData.time[1] = temp[key].totalHours;
                        this.chartData.payroll[1] = temp[key].totalMoney;
                        this.chartData.days[1] = temp[key].totalDays;
                        break;
                      }
                      case 'Mar':{
                        this.chartData.time[2] = temp[key].totalHours;
                        this.chartData.payroll[2] = temp[key].totalMoney;
                        this.chartData.days[2] = temp[key].totalDays;
                        break;
                      }
                      case 'Apr':{
                        this.chartData.time[3] = temp[key].totalHours;
                        this.chartData.payroll[3] = temp[key].totalMoney;
                        this.chartData.days[3] = temp[key].totalDays;
                        break;
                      }
                      case 'May':{
                        this.chartData.time[4] = temp[key].totalHours;
                        this.chartData.payroll[4] = temp[key].totalMoney;
                        this.chartData.days[4] = temp[key].totalDays;
                        break;
                      }
                      case 'Jun':{
                        this.chartData.time[5] = temp[key].totalHours;
                        this.chartData.payroll[5] = temp[key].totalMoney;
                        this.chartData.days[5] = temp[key].totalDays;
                        break;
                      }
                      case 'Jul':{
                        this.chartData.time[6] = temp[key].totalHours;
                        this.chartData.payroll[6] = temp[key].totalMoney;
                        this.chartData.days[6] = temp[key].totalDays;
                        break;
                      }
                      case 'Aug':{
                        this.chartData.time[7] = temp[key].totalHours;
                        this.chartData.payroll[7] = temp[key].totalMoney;
                        this.chartData.days[7] = temp[key].totalDays;
                        break;
                      }
                      case 'Sep':{
                        this.chartData.time[8] = temp[key].totalHours;
                        this.chartData.payroll[8] = temp[key].totalMoney;
                        this.chartData.days[8] = temp[key].totalDays;
                        break;
                      }
                      case 'Oct':{
                        this.chartData.time[9] = temp[key].totalHours;
                        this.chartData.payroll[9] = temp[key].totalMoney;
                        this.chartData.days[9] = temp[key].totalDays;
                        break;
                      }
                      case 'Nov':{
                        this.chartData.time[10] = temp[key].totalHours;
                        this.chartData.payroll[10] = temp[key].totalMoney;
                        this.chartData.days[10] = temp[key].totalDays;

                        break;
                      }
                      case 'Dec':{
                        this.chartData.time[11] = temp[key].totalHours;
                        this.chartData.payroll[11] = temp[key].totalMoney;
                        this.chartData.days[11] = temp[key].totalDays;
                        break;
                      }
                      default:{}
                    }
                  }
                this.dashboardChart('time');
                this.dashboardChart('payroll');
                this.dashboardChart('days');
                this.initBigChart(0);
                this.initBlueChart();
              }
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      dashboardChart(option){
        if (option === 'time'){
          this.bigLineChart.allData[0] = this.chartData.time;
        }
        else if(option === 'payroll'){
          this.bigLineChart.allData[1] = this.chartData.payroll;
        }
        else if(option === 'days'){
          this.blueBarChart.chartData.datasets.data = this.chartData.days;
          this.blueBarChart.chartData.labels = this.chartLabels;
        }
      },
    },
    mounted() {
      this.i18n = this.$i18n;

    },
    created() {
      this.getDashInfo();
    }
  };
</script>
<style>
</style>
